import React, { useState } from 'react';
import { Form, Button } from 'react-bootstrap';
import signup from "../assets/images/signup.webp";
import { Link } from 'react-router-dom';
import arrow from "../assets/images/arrow-left.png";
import resetPassword from "../assets/images/resetPassword.png";
import { forgotPasswordApi } from '../services/AuthApi';
import { showToast } from '../config/Alert';
import LoadingSpinner from './LoadingSpinner';

const ForgotPassword = () => {
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!email.trim()) {
            showToast("Email is required", "error");
            return;
        }

        setLoading(true);
        try {
            const response = await forgotPasswordApi({ email });
            showToast(response?.message || "Password reset link sent!", "success");
        } catch (error) {
            const errorMessage = error?.message || error?.response?.data?.message || "Failed to send reset link";
            showToast(errorMessage, "error");
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return <LoadingSpinner />;
    }

    return (
        <div className='login-form bg_light_yellow p-3'>
            <div className='login_main_form bg-white rounded-4'>
                <div className='text-center'>
                    <img src={resetPassword} alt="signup" className='img-fluid mb-3' />
                    <h1 className='fw-bold text-danger fs-20'>Forgot Password</h1>
                    <h6 className='text-muted fs-10'>Enter your email and we'll send you a link to reset your Password.</h6>
                </div>
                <Form className='mb-5 pt-3' onSubmit={handleSubmit}>
                    <Form.Group className="mb-3" controlId="email">
                        <Form.Control
                            type="text"
                            size='lg'
                            className='border-2 border-secondary fs-14'
                            placeholder='Enter email'
                            name="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                    </Form.Group>
                    <Form.Group className='text-center'>
                        <Button variant="info" size='lg' type="submit" className='px-5 text-white border-2 border-secondary'>
                            Submit
                        </Button>
                    </Form.Group>
                    <p className='text-center mt-2'><Link to='/login' className='fw-bold text-decoration-none fs-12 text-muted'><img src={arrow} width={10} alt="link" /> Back to login</Link></p>
                </Form>

                <img src={signup} alt="signup" className='img-fluid' />
            </div>
        </div>
    );
}

export default ForgotPassword;